import { render } from "./Instructions.vue?vue&type=template&id=14f82cc3&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=14f82cc3&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f82cc3"]])

export default __exports__